/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * Basic serializer for Chats.
 * @export
 * @interface Chat
 */
export interface Chat {
    /**
     *
     * @type {number}
     * @memberof Chat
     */
    readonly id: number;
    /**
     *
     * @type {string}
     * @memberof Chat
     */
    name?: string;
    /**
     *
     * @type {Array<ChatMessage>}
     * @memberof Chat
     */
    readonly messages: Array<ChatMessage>;
    /**
     *
     * @type {Date}
     * @memberof Chat
     */
    readonly createdAt: Date;
    /**
     *
     * @type {Date}
     * @memberof Chat
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Chat interface.
 */
export function instanceOfChat(value: object): value is Chat {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ChatFromJSON(json: any): Chat {
    return ChatFromJSONTyped(json, false);
}

export function ChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): Chat {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'messages': ((json['messages'] as Array<any>).map(ChatMessageFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function ChatToJSON(json: any): Chat {
      return ChatToJSONTyped(json, false);
  }

  export function ChatToJSONTyped(value?: Omit<Chat, 'id'|'messages'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'name': value['name'],
    };
}

